module.exports = __webpack_public_path__ + "img/zuijia_14.ea18e8e4.png";